<template>
	<div class="blacklist" ref="blacklistBox">
		<el-scrollbar v-if="items.length || loading" ref="scrollbar" class="blacklist-list" :style="listStyle">
			<div class="blacklist-item" v-for="item in items" :key="item.id">
				<head-image :size="42" :name="item.nickName" :url="item.headImage" :id="item.userId"></head-image>
				<div class="blacklist-info">
					<div class="blacklist-name">
						<div class="name-text" :title="item.nickName">{{ item.nickName }}</div>
						<div v-if="item.companyName" class="company-tag-mini" :title="item.companyName">@{{ item.companyName }}</div>
					</div>
				</div>
				<el-button size="mini" type="danger" plain @click="onRemove(item)">{{ $t('friend.removeBlacklist') }}</el-button>
			</div>
			<div v-if="loading" class="loading-tip">{{ $t('common.loading') }}</div>
			<div v-if="!loading && noMoreData && items.length > 0" class="no-more-tip">{{ $t('common.noMoreData') }}</div>
		</el-scrollbar>
		<no-data-tip v-else class="no-data-tip" :style="listStyle"></no-data-tip>
	</div>
</template>

<script>
import HeadImage from '../common/HeadImage.vue';
import NoDataTip from '../common/NoDataTip.vue';

export default {
	name: "blacklist",
	components: { HeadImage, NoDataTip },
	data() {
		return {
			items: [],
			loading: false,
			noMoreData: false,
			listHeight: 600,
			scrollWrap: null
		}
	},
	computed: {
		listStyle() {
			return `height:${this.listHeight}px`;
		},
		nextPageMaxId() {
			if (this.items.length > 0) {
				return this.items[this.items.length - 1].id;
			}
			return -1;
		}
	},
	methods: {
		initScrollEvent() {
			if (this.scrollWrap || !this.$refs.scrollbar) {
				return;
			}
			this.scrollWrap = this.$refs.scrollbar.$el.querySelector('.el-scrollbar__wrap');
			this.scrollWrap.addEventListener('scroll', this.onScroll);
		},
		onScroll(e) {
			const container = e.target;
			if (container.scrollTop + container.clientHeight >= container.scrollHeight - 30) {
				this.loadNextPage();
			}
		},
		loadNextPage() {
			if (this.loading || this.noMoreData) {
				return;
			}
			this.loading = true;
			this.$http({
				url: `/blacklist/page?maxPageId=${this.nextPageMaxId}`,
				method: 'GET'
			}).then((data) => {
				this.items.push(...data);
				this.noMoreData = data.length < 10;
			}).finally(() => {
				this.loading = false;
				this.$nextTick(() => this.initScrollEvent());
			});
		},
		onRemove(item) {
			this.$confirm(this.$t('friend.removeBlacklistConfirm', { name: item.nickName }), this.$t('friend.removeBlacklist'), {
				confirmButtonText: this.$t('common.ok'),
				cancelButtonText: this.$t('common.cancel'),
				type: 'warning'
			}).then(() => {
				this.$http({
					url: `/blacklist/remove?userId=${item.userId}`,
					method: 'DELETE'
				}).then(() => {
					this.items = this.items.filter(i => i.id !== item.id);
					this.$message.success(this.$t('chat.removedBlacklist', { name: item.nickName }));
				});
			});
		}
	},
	mounted() {
		this.listHeight = this.$refs.blacklistBox.offsetHeight;
		this.loadNextPage();
	},
	beforeDestroy() {
		if (this.scrollWrap) {
			this.scrollWrap.removeEventListener('scroll', this.onScroll);
		}
	}
}
</script>

<style scoped lang="scss">
.blacklist {
	flex: 1;
	display: flex;
	flex-direction: column;

	.blacklist-list {
		.blacklist-item {
			display: flex;
			align-items: center;
			padding: 12px 20px;
			border-bottom: 1px solid rgba(0, 0, 0, 0.04);

			.blacklist-info {
				flex: 1;
				padding-left: 12px;
				overflow: hidden;

				.blacklist-name {
					display: flex;
					align-items: center;

					.name-text {
						font-size: var(--im-font-size);
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
					}

					.company-tag-mini {
						flex: 1;
						min-width: 60px;
					}
				}
			}
		}

		.loading-tip,
		.no-more-tip {
			text-align: center;
			padding: 12px;
			color: var(--im-text-color-light);
			font-size: var(--im-font-size-small);
		}

	}
}
</style>
